export default __webpack_public_path__ + "static/1582-11f6ba144c045df489c2d3c6ad4c5263.gif";